var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgAntiguaandBarbuda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_6574)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5439 0H-3.54297V44.9561H63.5439V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3945 0.0527344H-3.48145V19.0459H63.4033L63.3945 0.0527344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.125 17.8594H6.74023V27.8613H51.125V17.8594Z",
    fill: "#0061FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.49902 0.158203V45H29.9697L-3.49902 0.149414V0.158203ZM63.4297 0.158203V45H29.9697L63.4297 0.149414V0.158203Z",
    fill: "#E20000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.29 17.8682L21.0049 16.1719L15.3008 11.8652L22.3057 12.8672L18.7021 6.75879L24.916 10.3623L23.791 3.25195L28.001 8.85938L29.6973 2.35547L31.6045 9.06152L35.8057 3.34863L34.6016 10.6611L40.8242 6.85547L37.2207 12.9639L44.0234 11.8652L38.416 16.0664L45.4385 17.8682H14.2988H14.29Z",
    fill: "#FFD600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_6574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgAntiguaandBarbuda);
export default __webpack_public_path__ + "static/media/ag Antigua and Barbuda.7a06fcb13517df0ad7e76379debdcbdb.svg";
export { ForwardRef as ReactComponent };